import styled from 'styled-components';
import Colors from 'styles/colors';
import { grid } from 'styles/grid';

// Matches the export status panel the order, media and file report exports
// already render from App.js. It has to be fixed rather than sit next to the
// button: the user export buttons live inside a ButtonMenu dropdown, which
// closes as soon as the export starts.
export const Container = styled.div`
  position: fixed;
  width: 23%;
  min-width: 280px;
  z-index: 999;
  padding: 8px 12px;
  color: ${Colors.white};
  right: 0;
  bottom: 0;
  background-color: ${Colors.nileBlue};
`;

export const Title = styled.div`
  font-size: 13px;
  margin-bottom: 6px;
`;

export const ProgressBarContainer = styled.div`
  ${grid};
  height: 14px;
  align-items: center;
  width: 100%;
  display: inline-grid;
`;

export const Progress = styled.div`
  height: inherit;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 50px;
`;

export const ProgressBar = styled.div`
  background-color: ${Colors.pictonBlue};
  width: ${({ xWidth }) => xWidth || 0};
  height: inherit;
  border-radius: 20px;
  transition: width 0.3s linear;
`;

export const ProgressText = styled.div`
  font-size: 12px;
  text-align: right;
`;

export const Detail = styled.div`
  font-size: 11px;
  margin-top: 5px;
  color: ${Colors.greyChateau};
  min-height: 14px;
`;
